<template lang="pug">
.m-card
  .m-card-header(:id="'heading-eatg-' + id" :data-bs-target="'#collapse-eatg-' + id" :aria-controls="'collapse-eatg-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_EATG", 1) }}
  .m-card-body.collapse.show(:id="'collapse-eatg-' + id" :aria-labelledby="'heading-eatg-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group
            template(v-for="item in col")
              template(v-if="moreItems['eatgo'][item] && moreItems['eatgo'][item][5] != 0 && moreItems['eatgo'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['eatgo'][item]" idx=5 :typ="oddsType" dataType="3" :label="item == '3Up' ? '3+' : item")
              template(v-else)
                OddsDisabled.col-more-scroll
        .odds-wrapper(v-if="$helpers.objSize(moreItems['eatgho']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T
          .odds-group
            template(v-for="item in col")
              template(v-if="moreItems['eatgho'][item] && moreItems['eatgho'][item][5] != 0 && moreItems['eatgho'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['eatgho'][item]" idx=5 :typ="oddsType" dataType="3" :label="item == '3Up' ? '3+' : item")
              template(v-else)
                OddsDisabled.col-more-scroll  
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-eatg-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-eatg-' + id"
//-     :aria-controls="'collapse-eatg-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_EATG") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-eatg-' + id"
//-     :id="'collapse-eatg-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }}
//-               template(v-if="moreItems['eatgo'][item] && moreItems['eatgo'][item][5] != 0 && moreItems['eatgo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['eatgo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="eatgo")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="$helpers.objSize(moreItems['eatgho']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }}
//-               template(v-if="moreItems['eatgho'][item] && moreItems['eatgho'][item][5] != 0 && moreItems['eatgho'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['eatgho'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="eatgho")
//-               template(v-else)
//-                 OddsDisabled



</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["0", "1", "2", "3Up"],
    }
  }
}
</script>
